import React, { useState } from 'react';
import { useTheme } from '@mui/joy';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import CommonUtils from 'utils/CommonUtils';

import Card from 'components/core/Card';
import Stack from 'components/core/Stack';
import Sheet from 'components/core/Sheet';
import Table from 'components/core/Table';
import IconButton from 'components/core/IconButton';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const EvidenceTable = ({ evidences, observation }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const data = evidences.map(evidence => {
        return evidence.getTableValues()
    });

    const columns = [
        { key: 'name', label: 'Name' },
        { key: 'format', label: 'Format' },
        { key: 'title', label: 'Title' },
        { key: 'repository', label: 'Repository' },
        { key: 'personName', label: 'Person Name' },
        { key: 'date', label: 'Date' },
    ];

    return (
        <Sheet sx={{ width: '100%', background: 'none', mt: 2, mb: 2 }}>
            <Card>
                <Table>
                    <thead>
                        <tr>
                            {columns.map(column => (
                                <th key={column.key}>
                                    <Stack direction="row" alignItems="center">
                                        {column.label}
                                    </Stack>
                                </th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(evidence => (
                            <tr key={evidence.id} >
                                {columns.map(column => (
                                    <td key={column.key}>{evidence[column.key]}</td>
                                ))}
                                <td>
                                    <Stack direction="row" alignItems="center" >
                                        Details
                                        <IconButton size="sm" onClick={() => {navigate(`/evidence/${evidence.id}`)}}>
                                            <ArrowOutwardIcon />
                                        </IconButton>
                                    </Stack>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>
        </Sheet>
    );
}

EvidenceTable.propTypes = {
    evidences: PropTypes.array.isRequired
};

export default EvidenceTable;